import style from './index.module.scss';
import cn from 'classnames';
interface IProps {
  pageKey?: string;
  menu?: Array<{ key: string }>;
  title?: string;
  bgImage: string;
  bgImageMobile?: string;
  className?: string;
}
export default function IndexView(props: IProps) {
  const { pageKey, menu = [], title, bgImage, bgImageMobile = bgImage, className } = props;
  return (
    <section className={cn(style.container, className)}>
      <div className={style['for-pc']}>
        <header className={style.header} style={{ backgroundImage: `url(${bgImage})` }}>
          {title}
        </header>
      </div>
      <div className={style['for-mobile']}>
        <header className={style.header} style={{ backgroundImage: `url(${bgImageMobile})` }}>
          {title}
        </header>
      </div>
      {menu.length > 0 && (
        <nav className={style.nav}>
          {menu.map((item: any) => {
            const { key, text, target = '_self' } = item;
            return (
              <a className={cn(style.navItem, pageKey === item.key && style.active)} target={target} rel="noreferrer" key={key} href={item.link}>
                {text}
              </a>
            );
          })}
        </nav>
      )}
    </section>
  );
}
